/* The 5th Note: Fragrance DNA pages (selection, rating, comparison, product block) */
(() => {
  const DNA = window.FifthDNA;
  if (!DNA) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  const money = (n) => (window.fifthNote ? window.fifthNote.money(Math.round(n * 100)) : 'R' + n).replace(/[.,]00(?!\d)/, '');

  const bars = (box, rows) => {
    box.innerHTML = '';
    rows.forEach((r) => {
      const row = el('div', 'dna-bar');
      row.appendChild(el('span', 'dna-bar__label', r.label));
      const track = el('span', 'dna-bar__track');
      const fill = el('span', 'dna-bar__fill');
      fill.style.width = Math.max(2, r.score * 10) + '%';
      track.appendChild(fill);
      row.appendChild(track);
      row.appendChild(el('span', 'dna-bar__num', String(Math.round(r.score))));
      row.setAttribute('aria-label', `${r.label} ${Math.round(r.score)} out of 10`);
      box.appendChild(row);
    });
  };

  const addToBag = async (variantId, props) => {
    const r = await fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props || {} }] })
    });
    if (!r.ok) throw new Error();
    const cart = await fetch(window.routes.cart_url + '.js').then((c) => c.json());
    if (window.fifthNote) window.fifthNote.setBagCount(cart.item_count);
  };

  const selectionCard = (x) => {
    const card = el('article', 'selc');
    card.dataset.handle = x.product.handle;
    const head = el('p', 'selc__slot');
    head.appendChild(el('span', '', x.label));
    head.appendChild(el('strong', '', x.pct + '% match'));
    card.appendChild(head);
    const media = el('div', 'selc__media');
    if (x.product.image) { const im = el('img'); im.src = x.product.image; im.alt = x.product.title; im.loading = 'lazy'; im.width = 400; im.height = 500; media.appendChild(im); }
    card.appendChild(media);
    const info = el('div', 'selc__info');
    info.appendChild(el('p', 'card__vendor', x.product.vendor || ''));
    info.appendChild(el('p', 'selc__title', x.product.title));
    info.appendChild(el('p', 'selc__price', money(x.product.price)));
    info.appendChild(el('p', 'selc__why', x.reason));
    const det = el('details', 'selc__more');
    det.appendChild(el('summary', '', 'Why this?'));
    const c = x.components;
    bars(det.appendChild(el('div', 'dna-bars dna-bars--sm')), [
      { label: 'Your taste', score: c.dna * 10 }, { label: 'The occasion', score: c.occasion * 10 }, { label: 'Something new', score: c.discovery * 10 }
    ]);
    info.appendChild(det);
    card.appendChild(info);
    return card;
  };

  /* ---------- Your fragrance selection ---------- */
  const sel = $('[data-dna-selection]');
  if (sel) (async () => {
    const state = DNA.load();
    if (!state || !state.answers) { $('.js-sel-empty', sel).hidden = false; return; }
    $('.js-sel-body', sel).hidden = false;
    const grid = $('.js-sel-grid', sel);
    grid.innerHTML = '<p class="picks__status">Comparing your Fragrance DNA with our catalogue\u2026</p>';
    let cat;
    try { cat = await DNA.loadCatalogue(); } catch (_) { grid.innerHTML = '<p class="muted">We couldn\u2019t load the catalogue. Refresh to try again.</p>'; return; }
    const c = DNA.buildCustomer(state, cat);
    const conf = DNA.confidence(c, state);
    $('.js-sel-stage', sel).textContent = DNA.stageLine(conf);
    $('.js-sel-desc', sel).textContent = DNA.describe(c);
    const all = DNA.DIMS.map((d, i) => ({ label: DNA.LABEL[d], score: c.p[i] }));
    const top = DNA.topTraits(c, 6).map((x) => ({ label: x.label, score: x.score }));
    const barBox = $('.js-sel-bars', sel);
    bars(barBox, top.length ? top : all.slice(0, 6));
    const allBtn = $('.js-sel-all', sel);
    allBtn.addEventListener('click', () => {
      const open = allBtn.getAttribute('aria-expanded') === 'true';
      bars(barBox, open ? (top.length ? top : all.slice(0, 6)) : all);
      allBtn.setAttribute('aria-expanded', String(!open));
      allBtn.textContent = open ? 'See all 30' : 'Show fewer';
    });

    const budgetIn = $('.js-sel-budget', sel), kindIn = $('.js-sel-kind', sel);
    if (state.answers.budget) budgetIn.value = state.answers.budget;
    kindIn.value = state.answers.kind === 'Both' ? '' : (state.answers.kind || '');
    let occasion = '';
    const occBox = $('.js-sel-occ', sel);
    const occBtns = [['', 'Any time']].concat(Object.keys(DNA.OCCASIONS).map((k) => [k, DNA.OCCASIONS[k].label]));
    occBtns.forEach(([k, label]) => {
      const b = el('button', 'chip-btn', label); b.type = 'button'; b.setAttribute('aria-pressed', String(k === occasion));
      b.addEventListener('click', () => { occasion = k; $$('.chip-btn', occBox).forEach((x) => x.setAttribute('aria-pressed', String(x === b))); run(); });
      occBox.appendChild(b);
    });
    const run = () => {
      const budget = Number(budgetIn.value) || 0;
      const rec = DNA.recommend(cat, c, { budget, kind: kindIn.value, occasion, excludeHandles: state.answers.loved || [], max: 7 });
      $('.js-sel-count', sel).textContent = `We analysed ${rec.analysed.toLocaleString('en-ZA')} fragrances against your personal Fragrance DNA.` +
        (rec.picks.length ? ` We found ${rec.picks.length} for you.` : '');
      grid.innerHTML = '';
      if (!rec.picks.length) { grid.appendChild(el('p', 'muted', 'Nothing fits those filters yet. Try a higher budget or show dupes and genuine.')); return; }
      rec.picks.forEach((x) => grid.appendChild(selectionCard(x)));
      DNA.aiReasons(c, rec.picks).then((r) => { if (r) $$('[data-handle]', grid).forEach((n) => { if (r[n.dataset.handle]) $('.selc__why', n).textContent = r[n.dataset.handle]; }); });
    };
    let t;
    budgetIn.addEventListener('input', () => { clearTimeout(t); t = setTimeout(run, 400); });
    kindIn.addEventListener('change', run);
    run();
  })();

  /* ---------- Rate your fragrances ---------- */
  const rate = $('[data-dna-rate]');
  if (rate) (async () => {
    const state = DNA.load();
    if (!state || !state.answers) { $('.js-rate-nodna', rate).hidden = false; return; }
    $('.js-rate-body', rate).hidden = false;
    const list = $('.js-rate-list', rate), save = $('.js-rate-save', rate), err = $('.js-rate-err', rate), result = $('.js-rate-result', rate);
    const items = new Map();
    // overall stars -> the engine's rating categories
    const STAR_RATING = { 5: 'loved', 4: 'liked', 3: 'okay', 2: 'not_for_me', 1: 'hated' };
    const STAR_WORD = { 1: 'Hated it', 2: 'Not for me', 3: "It's okay", 4: 'Liked it', 5: 'Loved it' };
    // smell-based star rows: [key, label, low end, high end]
    const ROWS = [
      ['overall', 'Overall', 'Hated it', 'Loved it'],
      ['scent', 'How it smelled on you', 'Unpleasant', 'Beautiful'],
      ['opening', 'First spray (opening)', 'Harsh', 'Gorgeous'],
      ['drydown', 'After a few hours (dry-down)', 'Unpleasant', 'Gorgeous'],
      ['longevity', 'How long it lasted', 'Under an hour', 'All day'],
      ['projection', 'How far it projected', 'Skin scent', 'Fills the room']
    ];
    const SMELL_TAGS = ['Too sweet', 'Not sweet enough', 'Too strong', 'Too light', 'Too fresh', 'Too floral', 'Too woody', 'Too spicy',
      'Too smoky', 'Too powdery', 'Too musky', 'Too heavy', 'Fades fast', 'Smelled expensive', 'Smelled cheap', 'Got compliments'];
    let uid = 0;
    const starRow = (key, label, lo, hi) => {
      const fs = el('fieldset', 'stars' + (key === 'overall' ? ' stars--main' : ''));
      fs.dataset.key = key;
      fs.appendChild(el('legend', 'stars__label', label));
      const row = el('div', 'stars__row');
      const g = 's' + (++uid);
      for (let i = 5; i >= 1; i--) {
        const inp = el('input'); inp.type = 'radio'; inp.name = g; inp.value = String(i); inp.id = g + '-' + i;
        const lab = el('label', '', '★'); lab.htmlFor = inp.id; lab.title = key === 'overall' ? STAR_WORD[i] : i + ' of 5';
        lab.setAttribute('aria-label', label + ': ' + i + ' of 5');
        row.appendChild(inp); row.appendChild(lab);
      }
      fs.appendChild(row);
      const hint = el('span', 'stars__hint', lo + ' → ' + hi);
      fs.appendChild(hint);
      if (key === 'overall') fs.addEventListener('change', () => { const v = (fs.querySelector('input:checked') || {}).value; hint.textContent = v ? STAR_WORD[v] : lo + ' → ' + hi; });
      return fs;
    };
    const addItem = (p) => {
      if (items.has(p.handle)) return;
      const card = el('article', 'ratec');
      card.appendChild(el('h2', 'ratec__title', (p.vendor ? p.vendor + ' ' : '') + p.title));
      if (p.notes) card.appendChild(el('p', 'ratec__notes', 'Notes: ' + p.notes));
      const grid = el('div', 'ratec__stars');
      ROWS.forEach(([k, l, lo, hi]) => grid.appendChild(starRow(k, l, lo, hi)));
      card.appendChild(grid);
      const tags = el('fieldset', 'chips ratec__tags');
      tags.appendChild(el('legend', 'stars__label', 'How did it smell? Tap any that fit'));
      SMELL_TAGS.forEach((t) => { const lab = el('label', 'chip'); const i = el('input'); i.type = 'checkbox'; i.value = t; lab.appendChild(i); lab.appendChild(el('span', '', t)); tags.appendChild(lab); });
      card.appendChild(tags);
      const ck = el('div', 'ratec__checks');
      [['wear_again', 'Would wear again'], ['purchase', 'Would buy a full bottle']].forEach(([k, l]) => {
        const lab = el('label', 'check'); const i = el('input'); i.type = 'checkbox'; i.dataset.key = k; lab.appendChild(i); lab.appendChild(document.createTextNode(' ' + l)); ck.appendChild(lab);
      });
      card.appendChild(ck);
      const cm = el('label', 'field'); cm.appendChild(el('span', 'field__label', 'Anything to add? (e.g. "love it but too sweet")'));
      const ta = el('textarea', 'field__input'); ta.rows = 2; ta.dataset.key = 'comment'; cm.appendChild(ta);
      card.appendChild(cm);
      const rm = el('button', 'link link--sm', 'Remove'); rm.type = 'button';
      rm.addEventListener('click', () => { items.delete(p.handle); card.remove(); save.hidden = !items.size; });
      card.appendChild(rm);
      list.appendChild(card);
      items.set(p.handle, { p, card });
      save.hidden = false;
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    // library fragrances (the search engine's 4,000+) turned into the engine's 30-trait vector
    const ENG = DNA.DIMS;
    const LIBD = ['freshness', 'sweetness', 'woody', 'spicy', 'smoky', 'creamy', 'citrus', 'fruity', 'floral', 'aquatic', 'green', 'projection', 'longevity', 'warmth', 'versatility', 'intensity'];
    const NOTE_DIMS = { herbal: /lavender|sage|basil|mint|rosemary|thyme|herb|aromatic/, powdery: /iris|orris|powder|violet|heliotrope|aldehyde/, musky: /musk/,
      amber: /amber|labdanum|benzoin|resin|ambroxan/, vanilla: /vanill|tonka/, oud: /oud|agarwood/, leather: /leather|suede/, tobacco: /tobacco/, earthy: /vetiver|patchouli|moss|earth/ };
    const libProduct = (it) => {
      const lv = Object.fromEntries(LIBD.map((d, i) => [d, it.dna[i]]));
      const notes = (it.notes || '').toLowerCase();
      const v = ENG.map((d) => {
        if (lv[d] != null) return lv[d];
        if (NOTE_DIMS[d]) return NOTE_DIMS[d].test(notes) ? 7 : 2;
        if (d === 'dryness') return Math.max(0, Math.min(10, (lv.woody + lv.spicy) / 2 - lv.sweetness / 3 + 2));
        if (d === 'cleanliness') return Math.max(0, Math.min(10, (lv.freshness + lv.aquatic + lv.citrus) / 3 + (/musk/.test(notes) ? 1 : 0)));
        if (d === 'seductiveness') return (lv.warmth + lv.sweetness + lv.intensity) / 3;
        if (d === 'complexity') return Math.min(10, 3 + notes.split(',').filter(Boolean).length * 0.5);
        return 5;
      });
      const key = (it.brand + ' ' + it.name).toLowerCase().replace(/[^a-z0-9]+/g, '-');
      return { handle: 'lib-' + key, vendor: it.brand, title: it.name, notes: it.notes, v, conf: 0.6, fromLibrary: true };
    };
    let cat;
    try { cat = await DNA.loadCatalogue(); } catch (_) { err.textContent = 'We couldn\u2019t load the catalogue. Refresh to try again.'; err.hidden = false; return; }
    rateSearch($('.js-rate-input', rate), cat, libProduct, addItem);
    new URLSearchParams(location.search).get('items')?.split(',').forEach((h) => { const p = cat.byHandle[h.trim()]; if (p) addItem(p); });

    save.addEventListener('click', async () => {
      err.hidden = true;
      const ratings = [];
      for (const { p, card } of items.values()) {
        const star = (k) => Number((card.querySelector(`.stars[data-key="${k}"] input:checked`) || {}).value) || null;
        const overall = star('overall');
        if (!overall) { err.textContent = `Give ${p.title} an overall star rating.`; err.hidden = false; card.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        const r = STAR_RATING[overall];
        const get = (k) => card.querySelector(`[data-key="${k}"]`);
        const tags = Array.from(card.querySelectorAll('.ratec__tags input:checked')).map((i) => i.value);
        const comment = [get('comment').value.trim()].concat(tags.map((t) => t.toLowerCase())).filter(Boolean).join('. ').slice(0, 500);
        const rec = {
          handle: p.handle, title: (p.fromLibrary && p.vendor ? p.vendor + ' ' : '') + p.title, rating: r, stars: overall,
          scent: star('scent'), opening: star('opening'), drydown: star('drydown'),
          longevity: star('longevity'), projection: star('projection'), smell_tags: tags.join(', '),
          wear_again: get('wear_again').checked ? true : (r === 'not_for_me' || r === 'hated' ? false : null),
          purchase: get('purchase').checked, comment
        };
        if (p.fromLibrary) rec.v = p.v.map((x) => Math.round(x * 10) / 10);
        ratings.push(rec);
      }
      if (!ratings.length) return;
      save.disabled = true;
      const res = DNA.addRatings(ratings, cat);
      const st = DNA.load();
      const c = res.c;
      result.innerHTML = '';
      result.appendChild(el('h2', 'h3', 'Thanks. Your Fragrance DNA is updated.'));
      result.appendChild(el('p', '', DNA.describe(c)));
      const ul0 = el('ul', 'rate__changes');
      ratings.forEach((r) => {
        const good = r.rating === 'loved' || r.rating === 'liked';
        const bad = r.rating === 'not_for_me' || r.rating === 'hated';
        ul0.appendChild(el('li', '', r.rating === 'hated' ? `We'll never send ${r.title} again.` : good ? `More like ${r.title}.` : bad ? `Less like ${r.title}.` : `Noted for ${r.title}.`));
      });
      result.appendChild(ul0);
      if (res.changes.length) {
        const ul = el('ul', 'rate__changes');
        res.changes.slice(0, 6).forEach((ch) => ul.appendChild(el('li', '', `${ch.d}: ${ch.from} \u2192 ${ch.to}`)));
        result.appendChild(ul);
      }
      const a = el('a', 'btn btn--foil', 'See your updated selection'); a.href = '/search?view=your-selection';
      result.appendChild(a);
      result.hidden = false;
      list.innerHTML = ''; items.clear(); save.hidden = true; save.disabled = false;
      const sum = DNA.summaryForSheet(c, st);
      ratings.forEach((r) => { const row = Object.assign({ type: 'rating', member: (st.contact || {}).member || '', email: (st.contact || {}).email || '' }, r, sum); delete row.v; DNA.postSheet(row); });
    });
  })();


  /* Rate page search: the store catalogue plus the full fragrance library */
  function rateSearch(input, cat, libProduct, onPick) {
    const box = el('div', 'ta'); box.setAttribute('role', 'listbox'); box.hidden = true;
    input.setAttribute('autocomplete', 'off'); input.setAttribute('role', 'combobox'); input.setAttribute('aria-expanded', 'false');
    input.insertAdjacentElement('afterend', box);
    const nrm = (x) => String(x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    let opts = [], active = -1, t, seq = 0;
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const pick = (p) => { onPick(p); input.value = ''; close(); };
    const render = async () => {
      const q = nrm(input.value); const my = ++seq;
      if (q.length < 2) return close();
      const words = q.split(' ');
      const fromCat = cat.list.filter((p) => { const x = nrm(p.vendor + ' ' + p.title); return words.every((w) => x.includes(w)); }).slice(0, 6);
      let fromLib = [];
      if (window.FifthSearch) {
        try {
          const r = await window.FifthSearch.search(input.value);
          const all = (r.hits || []).map((h) => h.it).filter((it) => !it.of && it.dna);
          const byName = all.filter((it) => { const x = nrm(it.brand + ' ' + it.name); return words.every((w) => x.includes(w)); });
          fromLib = byName.length ? byName : all.slice(0, 5); // typo-tolerant fallback
        } catch (_) {}
      }
      if (my !== seq) return;
      const seen = new Set(fromCat.map((p) => nrm(p.vendor + ' ' + p.title)));
      opts = fromCat.concat(fromLib.filter((it) => !seen.has(nrm(it.brand + ' ' + it.name))).slice(0, 10 - fromCat.length).map(libProduct));
      box.innerHTML = '';
      opts.forEach((p, k) => {
        const o = el('div', 'ta__opt', (p.vendor ? p.vendor + ' — ' : '') + p.title);
        o.setAttribute('role', 'option'); o.id = 'rate-opt-' + k;
        o.addEventListener('mousedown', (e) => { e.preventDefault(); pick(p); });
        box.appendChild(o);
      });
      if (!opts.length) box.appendChild(el('div', 'ta__empty', 'No match yet. Try the brand, or just part of the name.'));
      box.style.top = (input.offsetTop + input.offsetHeight) + 'px';
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
    };
    input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(render, 160); });
    input.addEventListener('blur', () => setTimeout(close, 120));
    input.addEventListener('keydown', (e) => {
      if (box.hidden || !opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        Array.from(box.children).forEach((c, k) => c.classList.toggle('is-active', k === active));
        input.setAttribute('aria-activedescendant', 'rate-opt-' + active);
      } else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(opts[active]); }
      else if (e.key === 'Escape') close();
    });
  }

  /* ---------- Staff comparison tool ---------- */
  const cmp = $('[data-dna-compare]');
  if (cmp && $('.js-cmp-table', cmp)) (async () => {
    const table = $('.js-cmp-table', cmp);
    const chosen = [];
    const meBox = $('.js-cmp-me', cmp);
    let cat;
    try { cat = await DNA.loadCatalogue(); } catch (_) { table.textContent = 'Catalogue could not be loaded.'; return; }
    const render = () => {
      const cols = chosen.map((p) => ({ name: (p.vendor ? p.vendor + ' ' : '') + p.title, v: p.v, src: p.source }));
      const st = DNA.load();
      if (meBox.checked && st && st.answers) cols.push({ name: 'Saved DNA (this device)', v: DNA.buildCustomer(st, cat).p, src: 'customer' });
      table.innerHTML = '';
      if (!cols.length) return;
      const thead = el('thead'); const hr = el('tr'); hr.appendChild(el('th', '', 'Characteristic'));
      cols.forEach((c, k) => {
        const th = el('th'); th.appendChild(el('span', '', c.name)); th.appendChild(el('small', 'muted', c.src === 'draft' ? ' (draft from tags)' : ''));
        if (k < chosen.length) { const x = el('button', 'link link--sm', 'Remove'); x.type = 'button'; x.addEventListener('click', () => { chosen.splice(k, 1); render(); }); th.appendChild(x); }
        hr.appendChild(th);
      });
      thead.appendChild(hr); table.appendChild(thead);
      const tb = el('tbody');
      DNA.DIMS.forEach((d, i) => {
        const vals = cols.map((c) => c.v[i]);
        const spread = Math.max(...vals) - Math.min(...vals);
        const tr = el('tr', spread >= 2 && cols.length > 1 ? 'is-diff' : '');
        tr.appendChild(el('th', '', DNA.LABEL[d]));
        vals.forEach((v) => {
          const td = el('td');
          const track = el('span', 'dna-bar__track'); const fill = el('span', 'dna-bar__fill'); fill.style.width = Math.max(2, v * 10) + '%'; track.appendChild(fill);
          td.appendChild(track); td.appendChild(el('span', 'dna-bar__num', v.toFixed(1)));
          tr.appendChild(td);
        });
        tb.appendChild(tr);
      });
      table.appendChild(tb);
    };
    DNA.typeahead($('.js-cmp-input', cmp), (p) => { if (chosen.length < 4 && !chosen.includes(p)) chosen.push(p); render(); });
    meBox.addEventListener('change', render);
  })();

  /* ---------- Product page DNA block ---------- */
  $$('.js-product-dna').forEach(async (box) => {
    const raw = {
      handle: box.dataset.handle, dna: box.dataset.dna || null,
      tags: (box.dataset.tags || '').split(',').filter(Boolean), notes_top: box.dataset.notes || '', available: true
    };
    const p = DNA.prepareProduct(raw);
    if (!p.hasData) { box.hidden = true; return; }
    const rows = DNA.DIMS.map((d, i) => ({ label: DNA.LABEL[d], score: p.v[i], i }))
      .filter((r) => r.i < 20).sort((a, b) => b.score - a.score).slice(0, 5)
      .concat([{ label: 'Projection', score: p.v[DNA.DIMS.indexOf('projection')] }, { label: 'Longevity', score: p.v[DNA.DIMS.indexOf('longevity')] }]);
    bars($('.js-pdna-bars', box), rows);
    $('.js-pdna-source', box).textContent = p.source === 'scored' ? 'Scored by our fragrance panel.' : 'Estimated from its notes.';
    const st = DNA.load();
    if (st && st.answers) {
      let cat = null;
      try { cat = await DNA.loadCatalogue(); } catch (_) {}
      const fp = (cat && cat.byHandle[p.handle]) || p;
      const c = DNA.buildCustomer(st, cat);
      const sim = DNA.dnaSimilarity(fp, c, null);
      const { R } = DNA.components(fp, c, {}, sim);
      const m = $('.js-pdna-match', box);
      m.textContent = DNA.toPct(R) + '% match for you';
      m.hidden = false;
    }
  });
})();
